import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  allDesignation,
  allQualification,
  allSpecialization,
} from "../../../../../../../../features/admin/common/Slice";
import { formatDate } from "../../../../../../../../utils/common";

const Personal_Report_Table = ({
  setEdit,
  data,
  setCurrentPage,
  currentPage,
}) => {
  const tableData = data?.data || [];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const perPage = data?.per_page || tableData.length || 0;

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Date</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Experience</th>
                <th>Qualification</th>
                <th>Specialization</th>
                <th>Relevant Training</th>
                <th>Contact No.</th>
                <th>Email</th>
              </tr>
            </thead>

            <tbody>
              {tableData.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    No data found
                  </td>
                </tr>
              ) : (
                tableData.map((row, index) => (
                  <tr key={row.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    <td>
                      {/* {new Date(row?.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })} */}
                       {formatDate(row?.createdAt)}
                    </td>
                    <td>{row.name}</td>
                    <td>{row.Designation?.name || "-"}</td>
                    <td>{row.experience} Years</td>
                    <td>{row.Qualification?.name || "-"}</td>
                    <td>{row.Specialization?.name || "-"}</td>
                    <td>{row.Relevant_Training?.name || "-"}</td>
                    <td>{row.contact_no}</td>
                    <td>{row.email}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {tableData.length} of {data?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={data?.total_pages || 1}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Personal_Report_Table;
